<script>
  import Header from "../components/Header.svelte";
  import TextReveal from "../components/TextReveal.svelte";
  import { copyToClipboard } from "../helper";

  let sending = false;
  let formStatus = { success: false, message: "" };

  async function submitForm() {
    sending = true;
    let contactForm = document.querySelector("form");

    try {
      const formData = new FormData(contactForm);
      let res = await fetch(contactForm.getAttribute("action"), {
        method: "POST",
        headers: {
          Accept: "application/x-www-form-urlencoded;charset=UTF-8",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: new URLSearchParams(formData).toString(),
      });

      if (res.ok) {
        formStatus = {
          success: true,
          message: "Message sent! I'll get back to you soon.",
        };
        contactForm.reset();
      } else {
        throw new Error("Failed to send");
      }
    } catch (error) {
      formStatus = {
        success: false,
        message: "Failed to send. Email me directly at manu1998kj@gmail.com",
      };
    } finally {
      sending = false;
      setTimeout(() => {
        formStatus = { success: false, message: "" };
      }, 5000);
    }
  }
</script>

<section id="contact" class="relative pt-36 pb-16">
  <Header title="Contact Me" subtitle="I'd love to hear from you!" />
  <!-- Main Content -->
  <div class="relative max-w-4xl mx-auto px-4">
    <!-- Contact Card -->
    <div class="relative group">
      <div
        class="relative z-10 rounded-3xl overflow-hidden
        transform transition-all duration-500 ease-out group-hover:scale-[1.01]"
      >
        <!-- Glow Effect -->
        <div
          class="absolute -inset-1 bg-gradient-to-r from-blue-500/20 to-purple-500/20
          rounded-3xl blur-xl opacity-20 group-hover:opacity-30 transition duration-1000"
        ></div>

        <!-- Content -->
        <div
          class="relative bg-white/5 dark:bg-gray-800/5 backdrop-blur-xl backdrop-saturate-[1.8]
          rounded-3xl p-8 lg:p-12 overflow-hidden border border-white/10 dark:border-gray-700/10
          shadow-[0_8px_32px_0_rgba(255,255,255,0.1)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.1)]
          hover:shadow-[0_20px_40px_-15px_rgba(255,255,255,0.15)] dark:hover:shadow-[0_20px_40px_rgba(0,0,0,0.15)]
          hover:border-white/20 dark:hover:border-gray-700/20
          transition-all duration-500"
        >
          <!-- Section Title -->
          <div class="mb-12">
            <div class="flex items-center gap-3 mb-6">
              <div
                class="h-1 w-12 rounded-full bg-gradient-to-r from-blue-500 to-purple-500"
              ></div>
              <div class="h-1 w-3 rounded-full bg-purple-500"></div>
              <div class="h-1 w-1 rounded-full bg-purple-500/50"></div>
            </div>

            <h2
              class="text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-4"
            >
              <TextReveal text="Let's Talk" />
            </h2>

            <p class="text-lg text-gray-600 dark:text-gray-300">
              Got a project in mind? Drop me a message or email me at
              <button
                class="inline-flex items-center gap-2 text-blue-500 dark:text-blue-400
                hover:text-blue-600 dark:hover:text-blue-300 transition-colors"
                on:click={() => copyToClipboard("manu1998kj@gmail.com")}
              >
                manu1998kj@gmail.com
                <svg
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                  />
                </svg>
              </button>
            </p>
          </div>

          <!-- Contact Form -->
          <form
            class="space-y-6"
            on:submit|preventDefault={submitForm}
            name="contact"
            action="action"
            method="POST"
            data-netlify="true"
            netlify-honeypot="bot-field"
          >
            <input type="hidden" name="form-name" value="contact" />
            <label class="hidden">
              Don't fill this out if you're human: <input name="bot-field" />
            </label>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div class="space-y-2">
                <label
                  class="text-sm font-medium text-gray-700 dark:text-gray-300"
                  for="name"
                >
                  Name
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  required
                  class="w-full px-4 py-2.5 rounded-lg
                  bg-white/10 dark:bg-gray-700/10 backdrop-blur-xl backdrop-saturate-[1.8]
                  border border-white/20 dark:border-gray-700/20
                  focus:border-blue-500/30 dark:focus:border-blue-400/30
                  focus:ring-2 focus:ring-blue-500/10 dark:focus:ring-blue-400/10
                  text-gray-900 dark:text-gray-100
                  placeholder-gray-500/70 dark:placeholder-gray-400/70
                  transition-all duration-300
                  hover:border-blue-100/30 dark:hover:border-blue-500/30"
                  placeholder="Your name"
                />
              </div>

              <div class="space-y-2">
                <label
                  class="text-sm font-medium text-gray-700 dark:text-gray-300"
                  for="email"
                >
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  class="w-full px-4 py-2.5 rounded-lg
                  bg-white/10 dark:bg-gray-700/10 backdrop-blur-xl backdrop-saturate-[1.8]
                  border border-white/20 dark:border-gray-700/20
                  focus:border-blue-500/30 dark:focus:border-blue-400/30
                  focus:ring-2 focus:ring-blue-500/10 dark:focus:ring-blue-400/10
                  text-gray-900 dark:text-gray-100
                  placeholder-gray-500/70 dark:placeholder-gray-400/70
                  transition-all duration-300
                  hover:border-blue-100/30 dark:hover:border-blue-500/30"
                  placeholder="your@email.com"
                />
              </div>
            </div>

            <div class="space-y-2">
              <label
                class="text-sm font-medium text-gray-700 dark:text-gray-300"
                for="message"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                required
                rows="6"
                class="w-full px-4 py-2.5 rounded-lg
                bg-white/10 dark:bg-gray-700/10 backdrop-blur-xl backdrop-saturate-[1.8]
                border border-white/20 dark:border-gray-700/20
                focus:border-blue-500/30 dark:focus:border-blue-400/30
                focus:ring-2 focus:ring-blue-500/10 dark:focus:ring-blue-400/10
                text-gray-900 dark:text-gray-100
                placeholder-gray-500/70 dark:placeholder-gray-400/70
                transition-all duration-300
                hover:border-blue-100/30 dark:hover:border-blue-500/30"
                placeholder="Tell me about your project..."
              ></textarea>
            </div>

            <!-- Form Status -->
            {#if formStatus.message}
              <div
                class="text-sm font-medium px-4 py-2 rounded-lg bg-white/10 dark:bg-gray-700/10 backdrop-blur-xl
                {formStatus.success ? 'text-green-500' : 'text-red-500'}"
              >
                {formStatus.message}
              </div>
            {/if}

            <div class="flex justify-end">
              <button
                type="submit"
                disabled={sending}
                class="group relative inline-flex items-center gap-2 px-6 py-3 rounded-xl
                bg-gradient-to-r from-blue-500 to-purple-500
                text-white font-medium
                shadow-lg shadow-blue-500/25
                hover:shadow-blue-500/40
                transform hover:-translate-y-0.5
                transition-all duration-300
                disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {#if sending}
                  <svg class="animate-spin h-5 w-5" viewBox="0 0 24 24">
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                      fill="none"
                    />
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                {:else}
                  Send Message
                  <svg
                    class="w-5 h-5 transform transition-transform group-hover:translate-x-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    />
                  </svg>
                {/if}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

<style>
  @keyframes mesh-1 {
    0% {
      transform: translateY(0) rotate(0deg);
    }
    50% {
      transform: translateY(-20px) rotate(180deg);
    }
    100% {
      transform: translateY(0) rotate(360deg);
    }
  }

  @keyframes mesh-2 {
    0% {
      transform: translateY(0) rotate(360deg);
    }
    50% {
      transform: translateY(20px) rotate(180deg);
    }
    100% {
      transform: translateY(0) rotate(0deg);
    }
  }

  .animate-mesh-1 {
    animation: mesh-1 20s ease-in-out infinite;
  }

  .animate-mesh-2 {
    animation: mesh-2 20s ease-in-out infinite;
  }

  .bg-gradient-conic {
    background-image: conic-gradient(var(--tw-gradient-stops));
  }
</style>
